import Utils from "@/utils/Default/Utils";
import PreFilterItem from "./PreFilterItem";
import {memo, useMemo} from "react";

const PreFilterItems = ({maxNumberPrefelter, concernedFilters, currentFiltersValue, applyFilters}) => {
    let preparedFilterNumber = 0;
    let prefelterList = []
    prefelterList = useMemo(() => {
        for (let i = 0; i < concernedFilters.length; i++) {
            if (concernedFilters[i][5].length > 0 && preparedFilterNumber < maxNumberPrefelter) {
                for (let j = 0; j < concernedFilters[i][5].length; j++) {
                    if (j < maxNumberPrefelter && preparedFilterNumber < maxNumberPrefelter) {
                        prefelterList.push(concernedFilters[i][5][j]);
                        preparedFilterNumber++;
                    } else {
                        break
                    }
                }
            }
            if (preparedFilterNumber === maxNumberPrefelter) {
                break;
            }
        }
        return prefelterList;
    }, [concernedFilters])
    return prefelterList.map(function (filter, index) {
        let applied = ((Object.keys(currentFiltersValue).includes(filter[2])))
        let action = applied ? "remove" : "apply";
        return (<PreFilterItem applyFilters={applyFilters} filter={filter} action={action}
                               applied={applied}
                               index={index} prepareLabelBloc={prepareLabelBloc}/>)
    });


}

function prepareLabelBloc(label) {
    if (Utils.hasWhiteSpace(label)) {
        return <> {label.substring(0, label.indexOf(' '))}
            <strong> {label.substring(label.indexOf(' ') + 1)}</strong> </>
    }
    return <>{label}</>

}


export const PreFilter = memo(({concernedFilters, maxNumberPrefelter, currentFiltersValue, applyFilters}) => {
    return (
        <ul className="dp__header__pre-filter">
            <PreFilterItems maxNumberPrefelter={maxNumberPrefelter}
                            concernedFilters={concernedFilters}
                            currentFiltersValue={currentFiltersValue}
                            applyFilters={applyFilters}
            />
        </ul>
    )
})